export const SUPERADMINMANAGEFLAVOR = "SUPERADMINMANAGEFLAVOR";
export const MANAGEFLAVORTYPE = "MANAGEFLAVORTYPE";
